import { isImmutableRecord } from 'app/common/utils/immutable-type-util';
import { type ChangeEvent, type ChangeEventHandler, useCallback } from 'react';
import type { WidgetProps } from '../../../types';
import { getWidgetId, useWidgetTitle } from '../../../util/widget';

export type StringWidgetHookProps = {
  label: string;
  value: string;
  handleChange: ChangeEventHandler<HTMLInputElement>;
  description?: string;
  maxLength?: number;
  id: string;
} & WidgetProps;

export const useStringWidget = (props: WidgetProps) => {
  const { schema, value, onChange, onBlur } = props;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(String(event.target.value));
      onBlur();
    },
    [onBlur, onChange]
  );

  const label = useWidgetTitle(props);
  const id = getWidgetId(props);

  return {
    ...props,
    label,
    value: String(isImmutableRecord(value) ? value.toJS() : value),
    handleChange,
    description: schema.get('description'),
    maxLength: schema.get('maxLength'),
    id
  };
};
